export default "__VITE_ASSET__B_j6tPdX__ 400w, __VITE_ASSET__BFYA51VJ__ 800w, __VITE_ASSET__C4BoyhZo__ 1024w";